import React, { useState, useMemo } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import {
  MultiPartnerForm,
  PartnerProfile,
} from "../../../../components/Admin/PartnersCmp";
import { useTranslation } from "react-i18next";
import "./Page_Partner_Profile.scss";

export function Page_Partner_Profile() {
  const { user } = useAuth();
  const { t } = useTranslation(["partners", "common"]);

  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  // 🔒 Normaliza 'holded' para evitar crashes y decisiones inconsistentes
  const holded = useMemo(() => {
    // String(...) convierte null/undefined en "null"/"undefined", por eso es mejor (v ?? "")
    // trim() quita espacios; toLowerCase() uniformiza comparaciones
    return (user?.user?.holded ?? "").toString().trim().toLowerCase();
  }, [user]);

  // ✅ Mostrar el botón "Alta Partner" solo si NO hay valor en holded
  // (si quieres otra lógica, p.ej. ocultar si holded === 'partner', ajusta aquí)
  const shouldShowAltaPartner = holded === "";

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <PartnerProfile reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="register-page">
        <div className="register-page__add">
          {shouldShowAltaPartner && (
            <Button onClick={onOpenCloseModal}>
              {t("common:actions.altaPartner")}
            </Button>
          )}
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("partners:profile.registrationTitle")}
      >
        <MultiPartnerForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          user={user}
        />
      </BasicModal>
    </>
  );
}
